import { cva } from 'class-variance-authority';

export const wrapperClasses = cva(
  'relative mb-2 w-full rounded-lg border border-dashed p-4 transition-all duration-200 ease-in-out'
);

export const rowClasses = cva('flex w-full items-center justify-center py-2');

export const fileInputClasses = cva(
  'absolute top-0 left-0 z-10 h-full w-full cursor-pointer opacity-0'
);

export const uploadedContainerClasses = cva('mt-2 w-full');

export const uploadedFileLeftClasses = cva('flex items-center p-2');

export const fileRemoveIconClasses = cva('cursor-pointer p-2');

export const paddingDivClasses = cva('p-2');

export const paddingLeftDivClasses = cva('pl-2');

export const uploadedFileClasses = cva(
  'mb-1 flex w-full items-center justify-between rounded-lg border-2 border-solid',
  {
    variants: {
      isValid: {
        true: 'border-success-900',
        false: 'border-danger-500',
        undefined: 'border-charcoal-alpha-50'
      }
    },
    defaultVariants: {
      isValid: undefined
    }
  }
);
